import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getSessionState } from '@client/selectors';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class IsAdminGuard implements CanActivate {
	constructor(private store: Store<any>, private router: Router) {}

	canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> {
		return this.store.pipe(
			select(getSessionState),
			filter(x => x && x.isLoaded),
			switchMap(u => {
				const isAdmin = u && u.claims && u.claims.admin;

				if (isAdmin) {
					return of(true);
				}

				return this.router.navigate(['/account/contract/details']);
			})
		);
	}
}
